// @ts-nocheck
import { capitalize } from 'lodash';
import {
  Address,
  ContactPoint,
} from 'src/nicheaim-infrastructure/application/adapters/out/repositories/fhir/resources';
import { createWrapper } from '../../fhir-react/base';

export const PractitionerWrapper = createWrapper('Practitioner', (practitioner) => ({
  getIdAsReference(): string {
    return `Practitioner/${practitioner?.id}`;
  },

  getFullName(): string | null {
    let fullName = null;
    if (practitioner.name?.[0]?.given?.[0] && practitioner.name?.[0]?.family) {
      fullName = `${practitioner.name?.[0]?.given?.[0]} ${practitioner.name?.[0]?.family}`;
    }
    return fullName;
  },

  getFullNameWithTitles(): string | null {
    if (!practitioner.name) return null;
    const { prefix, suffix, given, family } = practitioner.name[0];
    return [prefix?.[0], given?.[0], given?.[1]?.[0], family, suffix].filter((n) => n).join(' ');
  },

  getPrimaryAddress(): Address | null {
    let mainAddress = null;
    if (practitioner.address && practitioner.address?.length > 0) {
      mainAddress = practitioner.address[0];
    }
    return mainAddress;
  },

  getPrimaryAddressFormatted(): string | null {
    const mainAddress = this.getPrimaryAddress();

    if (!mainAddress) return null;

    const addr = [];
    if (mainAddress?.line) addr.push(mainAddress.line.filter((l) => l).join(' '));
    if (mainAddress?.city) addr.push(mainAddress.city);
    if (mainAddress?.state) addr.push(`${mainAddress.state},`);
    if (mainAddress?.postalCode) addr.push(mainAddress.postalCode);
    if (mainAddress?.use) addr.push(`(${capitalize(mainAddress.use)})`);

    return addr.join(' ');
  },

  getPrimaryPhone(): ContactPoint | null {
    let mainPhone = null;
    if (practitioner.telecom && practitioner.telecom?.length > 0) {
      const phones = practitioner.telecom.filter((t) => t?.system === 'phone');
      if (phones && phones?.length > 0) {
        mainPhone = phones[0];
      }
    }
    return mainPhone;
  },

  getPhones(): ContactPoint[] | null {
    return practitioner?.telecom?.filter((t) => t?.system === 'phone') || null;
  },

  getPrimaryEmail(): ContactPoint | null {
    let mainPhone = null;
    if (practitioner.telecom && practitioner.telecom?.length > 0) {
      const phones = practitioner.telecom.filter((t) => t?.system === 'email');
      if (phones && phones?.length > 0) {
        mainPhone = phones[0];
      }
    }
    return mainPhone;
  },

  getEmails(): ContactPoint[] | null {
    return practitioner?.telecom?.filter((t) => t?.system === 'email') || null;
  },
  getIdentifier(): { identifier: string | null; type: string | null } {
    return {
      identifier: practitioner?.identifier?.[0]?.value ?? null,
      type: practitioner?.identifier?.[0]?.system ?? null,
    };
  },
}));

export type WrappedPractitioner = ReturnType<typeof PractitionerWrapper>;
